<!-- Alerta para ativação de bandeiras -->
<div *ngIf="!empresa.exibirBandeiras " class="alert alert-warning" role="alert">
  <div class="d-flex align-items-center">
    <i class="k-icon k-i-warning text-warning mr-2"></i>
    <div>
      <strong>Atenção!</strong> Para integrar com <b>99 Food</b> é necessário ativar formas de pagamentos com bandeiras.
    </div>
  </div>
</div>



<!-- Conteúdo principal -->
<div *ngIf="empresa?.exibirBandeiras" class="container-fluid">
  <div class="row mb-4">
    <div class="col-12">
      <div class="d-flex align-items-center justify-content-between flex-wrap">
        <div class="mb-2">
          <h4 class="mb-1">
            <i class="k-icon k-i-link text-primary mr-2"></i>
            Integração com 99 Food
          </h4>
          <p class="text-muted mb-0">
            Autorize suas lojas no 99 Food e receba pedidos automaticamente no Meu Cardápio.
          </p>
        </div>
        <div class="mb-2">
          <button class="btn btn-primary"
                  type="button"
                  (click)="novaIntegracao99Food()"
                  [disabled]="carregando"
                  *ngIf="empresa?.id && !novaIntegracao">
            <i class="k-icon k-i-plus mr-2"></i>
            Nova integração
          </button>

          <button class="btn btn-warning ml-1"
                  *ngIf="empresa.integracoes99Food?.length "
                  (click)="sincronizarFormasPagamentos()"
                  [disabled]="sincronizando">
            <i class="k-icon k-i-refresh mr-1" [class.k-i-loading]="sincronizando"></i>
            Sincronizar Formas de Pagamento
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="row" *ngIf="mensagemErro">
    <div class="col-12">
      <div class="alert alert-danger">
        <i class="k-icon k-i-warning mr-2"></i>
        {{mensagemErro}}
      </div>
    </div>
  </div>

  <div class="row" *ngIf="carregando">
    <div class="col-12 text-center text-muted">
      <i class="k-icon k-i-loading mr-2"></i>
      Carregando lojas autorizadas no 99 Food...
    </div>
  </div>

  <div class="row" *ngIf="novaIntegracao && empresa?.id">
    <div class="col-12 col-lg-8">
      <app-form-integracao-99food
        [empresa]="empresa"
        [integracaoFood99]="novaIntegracao">
      </app-form-integracao-99food>
    </div>
  </div>

  <div class="row" *ngIf="!novaIntegracao && obtenhaIntegracoesFood99()?.length">
    <div class="col-12 col-lg-6 mb-4" *ngFor="let integracao of obtenhaIntegracoesFood99()">
      <app-form-integracao-99food
        [empresa]="empresa"
        [integracaoFood99]="integracao">
      </app-form-integracao-99food>
    </div>
  </div>

  <div class="row" *ngIf="!novaIntegracao && !obtenhaIntegracoesFood99()?.length && !carregando && !mensagemErro">
    <div class="col-12">
      <div class="alert alert-info">
        <i class="k-icon k-i-info mr-2"></i>
        Nenhuma loja 99 Food integrada. Clique em "Nova integração" para começar.
      </div>
    </div>
  </div>
</div>

